import React, { useState } from "react";
import { ChevronUpDownIcon } from "@heroicons/react/24/outline";
import "./table.css";

const TableHeader = ({ headers, onSorting }) => {
  const [sortingField, setSortingField] = useState("");
  const [sortingOrder, setSortingOrder] = useState("asc");
  const icon = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      fill="currentColor"
      className="inline-block w-4 h-4"
    >
      <path
        fillRule="evenodd"
        d="M10 2a.75.75 0 01.75.75v12.59l1.95-2.1a.75.75 0 111.1 1.02l-3.25 3.5a.75.75 0 01-1.1 0l-3.25-3.5a.75.75 0 111.1-1.02l1.95 2.1V2.75A.75.75 0 0110 2z"
        clipRule="evenodd"
      />
    </svg>
  );

  const onSortingChange = (field) => {
    const order =
      field === sortingField && sortingOrder === "asc" ? "desc" : "asc";

    setSortingField(field);
    setSortingOrder(order);
    onSorting(field, order);
  };
  return (
    <thead className="bg-coc-blue h-[70px] sticky top-0">
      <tr>
        {headers.map(({ name, field, sortable }) => (
          <th
            key={name}
            onClick={() => (sortable ? onSortingChange(field) : null)}
            scope="col"
            className="px-6 py-3 text-left text-sm font-light text-white resizable"
          >
            {field !== "companyLogo" && icon} {name}{" "}
          </th>
        ))}
      </tr>
    </thead>
  );
};

export default TableHeader;
